export const pointsDate = (value, timezone) => {
  if (!value || Number.isNaN(new Date(value).getTime())) return "Unknown date"
  try { return new Date(value).toLocaleString("en-GB", { timeZone: timezone || "UTC" }) } catch { return new Date(value).toISOString() }
}
